import axios from 'axios'

var NetClient = {
  ctx: { token: ''},
  sessionID: -1,
  resp: [],
  retval: 'OK',
  resetPid: -1,
  resetToken: '',
  recents: [],
  init: function(_router) {
    this.router = _router

    // Production safety: corrupted/localStorage from older builds can crash app boot.
    // If parsing fails, reset to a safe default.
    try {
      this.ctx = JSON.parse(window.localStorage.getItem('ctx'))
    } catch (e) {
      this.ctx = null
      try { window.localStorage.removeItem('ctx') } catch (_) {}
      console.error('Invalid ctx in localStorage; resetting.', e)
    }
    if (null == this.ctx) this.ctx = { token: '', uid: '', patienID: -1, uname: 'Not Logged In'}

    // parse any get variables
    // var query = window.location.search.substring(1)
    var query = window.location.href.split("?")
    var params = [], param = []
    var list = "";
    var ii = 0;

    if(window.location.href.search("\\?") != -1) {
      list = window.location.href.split("?")[1].split('&')
      for(ii=0;ii<list.length;ii++) {
        param = list[ii].split('=')
        if(param.length > 1) params[param[0]] = param[1]
      }
    }

    if(typeof params['pid'] != 'undefined') this.resetPid = params['pid']
    if(typeof params['token'] != 'undefined') this.resetToken = params['token']
  },
  logOut () {
      this.doRequest('rest/session',{action: 'logout'}).then(msg => {
        this.router.push({ name: 'Login'})
      })
  },

  // doRequest: function (_svc, _req) {
  doRequest: function (_svc, _req, _method) {
    var nc = this

    this.resp = []
    this.retval ='OK'

    _req.nw_token = this.ctx.token
    _req.nw_uid = this.ctx.uid
    
    if (typeof _method == "undefined") {
      _method = "post"
    }

    return new Promise(function (resolve, reject) {
      // axios(_data).then(axresp => {
      axios({
        method: _method,
        baseURL: process.env.VUE_APP_HOST_NAME,
        url: _svc,
        headers: { 'nw-uid': nc.ctx.uid, 'nw_uid': nc.ctx.uid },
        ...(_method.toUpperCase() === "POST" && { data: _req })
      }).then(axresp => {
        var msg = axresp.data

        if(typeof msg == 'undefined') {
          reject(new Error('Invalid response from server. No data element found'))
          return
        }

        if(typeof msg.resp != 'undefined') NetClient.resp = msg.resp
        if(typeof msg.retval != 'undefined') NetClient.retval = msg.retval

        if ('AUTH' === msg.retval) {
          nc.router.push({ name: 'Login'})
          resolve(msg)
        }

        if(typeof msg.data != 'undefined') {
          if(typeof msg.data.ctx !== 'undefined') {
            NetClient.ctx = msg.data.ctx
            window.localStorage.setItem('ctx', JSON.stringify(NetClient.ctx))
          }

          if(typeof msg.data.recents != 'undefined') NetClient.recents = msg.data.recents
        }
        resolve(msg)
      }).catch(err => {
        console.error('error in response: ' + err);
        reject(err)
      })
    })
  }
}

export default NetClient
